// Tab ID constants for group views
export const TAB_FEED = 1;
export const TAB_MEMBERS = 2;
export const TAB_EVENTS = 3;
export const TAB_LEADERBOARD = 4;
export const TAB_LADDER_GRAPH = 5;
export const TAB_LEAGUE_STATS = 6;
export const TAB_MATCHES = 7;
export const TAB_SCHEDULE = 8;
export const TAB_MEMBERSHIPS = 9;

// Mapping from tab route string to tab ID
export const tabMapping = {
    feed: TAB_FEED,
    members: TAB_MEMBERS,
    calendar: TAB_SCHEDULE,
    schedule: TAB_SCHEDULE,
    events: TAB_EVENTS,
    leaderboard: TAB_LEADERBOARD,
    'league-stats': TAB_LEAGUE_STATS,
    matches: TAB_MATCHES,
    memberships: TAB_MEMBERSHIPS,
    'ladder-graph': TAB_LADDER_GRAPH
};
